import * as Sentry from "@sentry/vue";
import { pushErrorEvent } from "vacv-common";

/**
 *
 * @param {Error} e An error that will be logged in Sentry and pushed to the DataLayer
 */

export interface LogExceptionCustomError {
  name: string;
  message: string;
}

export function logException(e: Error | LogExceptionCustomError) {
  Sentry.captureException(e);
  if (e instanceof Error) {
    pushErrorEvent(e);
  }
}
